import { render, staticRenderFns } from "./CounterpartiesAddComponent.vue?vue&type=template&id=32d7059a&scoped=true"
import script from "./CounterpartiesAddComponent.vue?vue&type=script&lang=ts"
export * from "./CounterpartiesAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7059a",
  null
  
)

export default component.exports